import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../api';
import { FONT_FAMILY } from '../constants/font';

// Pagina PUBLICA a la que llega el usuario desde el link del correo de
// "olvidé mi contraseña" (token de un solo uso, expira en 1h).
function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = (searchParams.get('token') || '').trim();
  const navigate = useNavigate();

  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) { setError('La contraseña debe tener al menos 8 caracteres.'); return; }
    if (pw !== pw2) { setError('Las contraseñas no coinciden.'); return; }
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, new_password: pw });
      setDone(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(detail || 'No se pudo restablecer la contraseña. El enlace pudo expirar.');
    } finally {
      setLoading(false);
    }
  };

  const wrap = {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #1A1A1A 0%, #2D1810 100%)',
    fontFamily: FONT_FAMILY, padding: 20,
  };
  const card = {
    background: '#fff', borderRadius: 16, padding: 32, maxWidth: 420, width: '100%',
    boxShadow: '0 24px 60px rgba(0,0,0,0.35)',
  };
  const label = {
    fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: 0.5,
  };
  const input = {
    width: '100%', padding: '12px 14px', marginTop: 6, marginBottom: 14,
    border: '1.5px solid #E5E7EB', borderRadius: 8, fontSize: 14,
    fontFamily: FONT_FAMILY, boxSizing: 'border-box',
  };

  // Estado: link sin token
  if (!token) {
    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#FF6B00', marginBottom: 12 }}>WH POP Rappi</div>
          <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 800, color: '#1A1A1A' }}>Enlace inválido</h2>
          <p style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.5, marginBottom: 20 }}>
            Este enlace está incompleto. Vuelve a solicitar el restablecimiento desde la pantalla de inicio de sesión.
          </p>
          <Link to="/login" style={{
            display: 'block', textAlign: 'center', padding: '12px',
            background: '#1A1A1A', color: '#fff', borderRadius: 8,
            fontSize: 14, fontWeight: 700, textDecoration: 'none',
          }}>
            Ir a iniciar sesión
          </Link>
        </div>
      </div>
    );
  }

  // Estado: éxito
  if (done) {
    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#FF6B00', marginBottom: 12 }}>WH POP Rappi</div>
          <div style={{
            padding: '14px 16px', background: '#ECFDF5', border: '1px solid #10B981',
            borderRadius: 8, fontSize: 14, color: '#065F46', lineHeight: 1.5, marginBottom: 20,
          }}>
            ✓ Tu contraseña se actualizó. Ya puedes iniciar sesión con la nueva.
          </div>
          <button onClick={() => navigate('/login')} style={{
            width: '100%', padding: '12px',
            background: 'linear-gradient(135deg, #FF6B00, #EA580C)', color: '#fff',
            border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer',
            fontFamily: FONT_FAMILY,
          }}>
            Iniciar sesión
          </button>
        </div>
      </div>
    );
  }

  // Estado: formulario
  return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#FF6B00', marginBottom: 12 }}>WH POP Rappi</div>
        <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 800, color: '#1A1A1A' }}>
          Crea tu nueva contraseña
        </h2>
        <p style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.5, marginBottom: 20 }}>
          Escribe tu nueva contraseña (mínimo 8 caracteres). El enlace expira a la hora de haberlo solicitado.
        </p>
        <form onSubmit={handleSubmit}>
          <label style={label}>Nueva contraseña</label>
          <input
            type="password" autoFocus value={pw} onChange={e => setPw(e.target.value)}
            placeholder="Mínimo 8 caracteres" required style={input}
          />
          <label style={label}>Confirmar contraseña</label>
          <input
            type="password" value={pw2} onChange={e => setPw2(e.target.value)}
            placeholder="Repite la contraseña" required style={input}
          />
          {error && (
            <div style={{
              marginBottom: 14, padding: '10px 12px', background: '#FEF2F2',
              border: '1px solid #EF4444', borderRadius: 6, fontSize: 12, color: '#991B1B',
            }}>
              {error}
            </div>
          )}
          <button type="submit" disabled={loading || !pw || !pw2} style={{
            width: '100%', padding: '12px',
            background: loading ? '#9CA3AF' : 'linear-gradient(135deg, #FF6B00, #EA580C)',
            color: '#fff', border: 'none', borderRadius: 8,
            fontSize: 14, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: FONT_FAMILY,
          }}>
            {loading ? 'Guardando...' : 'Restablecer contraseña'}
          </button>
        </form>
        <Link to="/login" style={{
          display: 'block', textAlign: 'center', marginTop: 16,
          fontSize: 13, color: '#6B7280', textDecoration: 'none',
        }}>
          Volver a iniciar sesión
        </Link>
      </div>
    </div>
  );
}

export default ResetPassword;
